import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/brain')({
  component: BrainLayout,
});

const TABS = [
  { key: 'ask', label: 'Ask', to: '/brain/ask' },
  { key: 'map', label: 'Map', to: '/brain/map' },
] as const;

function BrainLayout() {
  const { location } = useRouterState();
  const activeKey = location.pathname.endsWith('/map') ? 'map' : 'ask';

  return (
    <div className="flex h-[calc(100vh-1px)] flex-col px-6 py-5">
      <div className="mb-3 shrink-0">
        <h1 className="font-display text-3xl font-bold text-[var(--color-navy)]">Company Brain</h1>
        <p className="mt-1 max-w-3xl text-sm text-[var(--color-ink-soft)]">
          One layer over all our data. <span className="font-semibold">Ask</span> it questions in plain English,
          or explore the <span className="font-semibold">Map</span> of what it connects to. See{' '}
          <code className="font-mono text-xs">docs/COMPANY-BRAIN.md</code>.
        </p>
        <div className="mt-3 inline-flex gap-1 rounded-xl border border-[var(--color-line)] bg-[var(--color-surface-1)] p-1">
          {TABS.map((t) => (
            <Link
              key={t.key}
              to={t.to}
              className={
                'rounded-lg px-4 py-1.5 text-sm font-medium transition-colors ' +
                (activeKey === t.key
                  ? 'bg-[var(--color-navy)] text-white'
                  : 'text-[var(--color-ink)] hover:bg-white')
              }
            >
              {t.label}
            </Link>
          ))}
        </div>
      </div>
      <div className="min-h-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
